import script from "./CrudDisenos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudDisenos.vue?vue&type=script&setup=true&lang=js"

import "./CrudDisenos.vue?vue&type=style&index=0&id=a71a6488&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a71a6488"]])

export default __exports__